import { getCulture } from "../utils/Utils";

export const hostName = Tickets.appPath;

export const endpoints = {
  user: {
    getUser: "/_api/onboarding/get-user",
    updateUser: "/_api/onboarding/update-user",
  },
  gsis: {
    getCompany: (vat) => `/_api/gsis/company/?vat=${vat}`,
  },
  event: {
    getMedia: "/_api/events/media",
    getEvents: "/_api/playdetails/getevents",
    getvalue: "/_api/playdetails/getvalue",
    getDescription: (code, lang, translate) =>
      `/_api/playdetails/description?code=${code}&lang=${lang}&translate=${translate}`,
    getProducers: "/_api/playdetails/getProducers",
    getArtist: (artistId, culture) =>
      `/_api/artists/${artistId}?culture=${culture}`,
    getArtistMedia: (artistId, culture) =>
      `/_api/artists/${artistId}/media?culture=${culture}`,
    getArtistEventGroups: (artistId, culture) =>
      `/_api/artists/${artistId}/eventgroups?culture=${culture}`,
    getEventGroupArtists: (eventGroupId, culture) =>
      `/_api/artists/eventgroup/${eventGroupId}/?culture=${culture}`,
    followArtist: (artistId) => `/_api/artists/${artistId}/follow`,
    followEventGroup: (nodeId) => `/_api/follow/${nodeId}`,
  },
  events: {
    getEventsByProducer: (country, lang, producerId, categoryId = 0) => {
      let url = `/_api/home/producer-eventgroups?country=${country}&lang=${lang}`;
      if (producerId) url += `&producerId=${producerId}`;
      if (categoryId) url += `&categoryId=${categoryId}`;
      return url;
    },
  },
  reservation: {
    getReservation: (requestKey) => `/_api/reservations/${requestKey}`,
    finalize: (reservationGuid) => `/_api/reservations/${reservationGuid}/finalize`,
  },
  common: {
    getCountries: "/site/data/common/countries.ashx",
    getCities: (countryCode, lang) => `/site/data/common/cities.ashx?countryCode=${countryCode}&lang=${lang}`,
  },
};

export const eventPropKeys = [
  "duration",
  "intermission",
  "allowCancel",
  "allowUpdate",
  "hasParking",
  "hasSeats",
  "accessInfo",
  "venueId",
  "accessibility",
];

export const colors = {
  grey: "#F7F7F7",
};

export const APP_PROMO_URL = "https://onelink.to/325nmw";

export const buildLoginRedirectUrl = () => {
  const currentUrl = window.location.href;
    const lang = getCulture()?.split("-")[0] ?? "el";
  return `${window.location.origin}/Challenge.aspx?mode=reservation&origin=${encodeURIComponent(currentUrl)}&lang=${lang}`;
};

const _r = typeof playdetailsv2_resources !== "undefined" ? playdetailsv2_resources : {};

export const ACCESSIBILITY_OPTIONS = {
  WHEELCHAIR:     { bit: 1,    text: _r.WheelchairAvailableResource },
  RESTROOM:       { bit: 2,    text: _r.RestroomResource },
  RAMPS:          { bit: 4,    text: _r.RampsResource },
  EMERGENCY_EXITS:{ bit: 8,    text: _r.EmergencyExitsResource },
  ELEVATOR:       { bit: 16,   text: _r.ElevatorResource },
  PARKING:        { bit: 32,   text: _r.PRMParkingResource },
  HEARING_AID:    { bit: 64,   text: _r.HearingAidResource },
  VISUAL_AID:     { bit: 128,  text: _r.VisualAidsResource },
  COMPANION:      { bit: 256,  text: _r.CompanionResource },
  SERVICE_DOGS:   { bit: 512,  text: _r.ServiceDogsResource },
  SUBTITLES:      { bit: 1024, text: _r.SubtitlesResource },
};
